import React from "react";
import { Link } from "react-router-dom";
import { YCN_LOGO_URL, YCN_SOCIAL } from "@/data/constants";
import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  const cols = [
    { title: "Network", links: [
      { to: "/", label: "Home" },
      { to: "/awards", label: "YCN Awards" },
      { to: "/submit", label: "Creator Submissions" },
      { to: "/browse", label: "Browse All" },
    ]},
    { title: "Discover", links: [
      { to: "/originals", label: "YCN Originals" },
      { to: "/movies", label: "Movies" },
      { to: "/shows", label: "TV Shows" },
      { to: "/live", label: "Live TV" },
      { to: "/kids", label: "Kids" },
    ]},
    { title: "Company", links: [
      { to: "/about", label: "About YCN" },
      { to: "/advertise", label: "Advertise With Us" },
      { to: "#", label: "Contact" },
      { to: "#", label: "News" },
    ]},
    { title: "Legal", links: [
      { to: "#", label: "Privacy Policy" },
      { to: "#", label: "Terms of Use" },
      { to: "#", label: "Accessibility" },
      { to: "#", label: "Help Center" },
    ]},
  ];

  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-white/10 bg-[#050505]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <img src={YCN_LOGO_URL} alt="YCN" className="h-14 w-auto mb-5" />
            <p className="text-white/60 max-w-sm text-sm leading-relaxed">
              Your Channel Network is a Virginia Beach–based, woman-owned, mother-and-daughter-led streaming network built to entertain, inspire, and empower.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: Instagram, label: "Instagram", href: YCN_SOCIAL.instagram },
                { icon: Facebook, label: "Facebook", href: YCN_SOCIAL.facebook },
              ].map(({ icon: Icon, label, href }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`footer-social-${label.toLowerCase()}`}
                  className="h-10 w-10 rounded-full ycn-glass hover:bg-white/10 flex items-center justify-center text-white/70 hover:text-white transition">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-display font-semibold text-white text-sm uppercase tracking-[0.2em] mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-white/60 hover:text-white transition">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-display text-lg">
            <span className="ycn-gradient-text font-extrabold uppercase tracking-wider">Your Story. Your Voice. Your Channel.</span>
          </p>
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Your Channel Network. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
